import { Button, Divider, Paper, Stack } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onSave: () => void;
  onCancel: () => void;
  hasUnsavedChanges: boolean;
};

export const BottomToolbar: React.FC<Props> = ({
  onSave,
  onCancel,
  hasUnsavedChanges,
}) => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        bottom: 16,
        left: "50%",
        transform: "translateX(-50%)",
        px: 2,
        py: 1,
        borderRadius: 2,
        display: "flex",
        gap: 2,
        zIndex: 10,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          disabled={!hasUnsavedChanges}
        >
          {t("common.save")}
        </Button>
        <Divider orientation="vertical" flexItem />
        <Button variant="outlined" onClick={onCancel}>
          {t("common.cancel")}
        </Button>
      </Stack>
    </Paper>
  );
};
